module.exports = __webpack_public_path__ + "img/21.2d2efbd4.svg";